import { useSubtitleChecker } from "@/components/widget/logic/useSubtitleChecker";

export const subtitle = {
    namespaced: true,
    state: {

        subtitleURL: null,

        subtitleName: "",

        subtitleExists: false,

        sync: 0

    },
    mutations:{
        setSubtitleURL(state, url) {
            state.subtitleURL = url;
        },


        setSubtitleName(state, name) {
            state.subtitleName = name;
        },


        setSubtitleExists(state, value) {
            state.subtitleExists = value;
        },


        setSync(state, value) {
            state.sync = value;
        }

    },
    actions: {


        async adjustSync({ state, commit, dispatch }, ms) {

            commit(
                "setSync",
                state.sync + ms
            );


            await dispatch(
                "reloadSubtitle"
            );

        },


        async resetSync({ commit, dispatch }) {

            commit(
                "setSync",
                0
            );


            await dispatch(
                "reloadSubtitle"
            );

        },


        async reloadSubtitle({ state, commit }) {

            if (!state.subtitleName)
                return;


            const {
                getSubtitle
            } = useSubtitleChecker();


            const result =
                await getSubtitle(
                    state.subtitleName,
                    state.sync
                );


            if (result) {

                commit(
                    "setSubtitleURL",
                    result.url
                );


                commit(
                    "setSubtitleName",
                    result.name
                );


                commit(
                    "setSubtitleExists",
                    true
                );

            }

        },
        async selectSubtitle({ commit, dispatch }, item) {

            commit(
                "setSubtitleName",
                item.name
            );


            commit(
                "setSubtitleURL",
                item.url
            );


            commit(
                "setSubtitleExists",
                true
            );


            await dispatch(
                "reloadSubtitle"
            );

        }

    }
}